import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {SaveGamesWidgetBox} from "./boxes/save-games-widget.box";
import {SaveGamesWidgetGamesContainerBox} from "./boxes/save-games-widget-games-container.box";
import {GameImageComponent} from "../../single-game/common/parts/game-image/game-image.component";
import {GameItemImgWrapperBox} from "../../game-item/boxes/game-item-img-wrapper.box";
import {SaveGamesWidgetGamesTitleBox} from "./boxes/save-games-widget-games-title.box";
import {SaveGamesWidgetHeaderComponent} from "./save-games-widget-header.component";
import {observer} from "mobx-react";


export const SaveGamesWidgetComponent = observer(class SaveGamesWidgetComponent extends OrbitComponent<{}> {

    private _onGameClick(gameType: number) {
        this.services.games.gamesMap[gameType]?.open({
            isRealMode: true,
            listTitle: "SAVED_GAMES_WIDGET"
        });
    }

    render() {
        if (this.services.games.savedGameTypes.length === 0) {
            return null;
        }

        if (!this.services.configuration.data.drawer.saveGamesWidget?.display) {
            return null;
        }

        return (
            <SaveGamesWidgetBox className={'cy-save-games-widget'}>
                <SaveGamesWidgetHeaderComponent/>
                <SaveGamesWidgetGamesContainerBox>
                    {this.services.games.savedGameTypes.slice(0,6).map(gt => this.services.games.gamesMap[gt]).map(gi =>
                        !gi ? null :
                        <div>
                            <GameItemImgWrapperBox fixedWidth className={`cy-saved-game-${gi.gameType}`} onClick={() => this._onGameClick(gi.gameType)}>
                                <GameImageComponent gameInfo={gi} useLazyLoading={true} useSquareIcons disableAnimation/>
                            </GameItemImgWrapperBox>
                            <SaveGamesWidgetGamesTitleBox>
                                {gi.title}
                            </SaveGamesWidgetGamesTitleBox>
                        </div>
                    )}
                </SaveGamesWidgetGamesContainerBox>
            </SaveGamesWidgetBox>
        );
    }
});
